import { useQuery } from "@tanstack/react-query";
import { getStations, getLanguages } from "../api/stations";

export const useStations = () => {
  return useQuery({
    queryKey: ["stations"],
    queryFn: getStations,
  });
};

export const useLanguages = () => {
  return useQuery({
    queryKey: ["languages"],
    queryFn: getLanguages,
    // Езиците се менят рядко — държим ги свежи дълго.
    staleTime: 5 * 60 * 1000,
  });
};
